import Vue from "vue";
import App from "./App";
import router from "./router";
import editor from "@tinymce/tinymce-vue";
import CoreuiVue from "@coreui/vue";
import "./mixins/generalMixin";
import "./main.css";
import { iconsSet as icons } from "./assets/icons/icons.js";
import { i18n } from "./plugins/i18n";
import VueCookies from "vue-cookies";
import Vuelidate from "vuelidate";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueMoment from "vue-moment";
import vueNumeralFilterInstaller from "vue-numeral-filter";
import ToggleButton from "vue-js-toggle-button";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "./store";
import VueEllipseProgress from "vue-ellipse-progress";
import { ColorPicker, ColorPanel } from "one-colorpicker";
import dotenv from "dotenv";
dotenv.config();

const moment = require("moment");
require("moment/locale/th");
// import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "tinymce/tinymce";

// Theme
import "tinymce/themes/silver/theme";

// Skins
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";
import "tinymce/skins/content/default/content.min.css";

// Plugins
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/paste";
import "tinymce/plugins/autoresize";

import "babel-polyfill";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { Settings as LuxonSettings } from "luxon";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

//Icon
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEyeSlash,
  faPowerOff,
  faUser,
  faStore,
  faBullhorn,
  faSearch,
  faFileUpload,
  faFilter,
  faSortDown,
  faPencilAlt,
  faTrashAlt,
  faTimes,
  faTimesCircle,
  faFileDownload,
  faEye,
  faBarcode,
  faPlus,
  faMinus,
  faStar,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faHome,
  faBuilding,
  faHotel,
  faCircle,
  faArrowRight,
  faClipboard,
  faBox,
  faSort,
  faHandHoldingUsd,
  faPlusCircle,
  faCheckCircle,
  faExclamationCircle,
  faEllipsisV,
  faCheck,
  faMapMarkerAlt,
  faMapMarkedAlt,
  faStickyNote,
  faShippingFast,
  faMoneyBillWave,
  faReceipt,
  faUserCheck,
  faUserPlus,
  faPercent,
  faRobot,
  faFileExport,
  faUserFriends,
  faCommentAlt,
  faSmile,
  faAngry,
  faMobileAlt,
  faWindowMaximize,
  faMap,
  faImage,
  faSave,
  faPlusSquare,
  faCopy,
  faSortUp,
  faSyncAlt,
  faArchive
} from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarFar } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  fab,
  faFacebookF,
  faInstagram,
  faLine,
  faTwitter,
  faApple,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
library.add(
  fab,
  faFacebookF,
  faInstagram,
  faLine,
  faTwitter,
  faApple,
  faYoutube
);
library.add(
  faEyeSlash,
  faUser,
  faPowerOff,
  faStore,
  faBullhorn,
  faSearch,
  faFilter,
  faFileUpload,
  faSortDown,
  faPencilAlt,
  faTrashAlt,
  faTimes,
  faTimesCircle,
  faFileDownload,
  faEye,
  faBarcode,
  faPlus,
  faMinus,
  faStar,
  faStarFar,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faHome,
  faBuilding,
  faHotel,
  faCircle,
  faArrowRight,
  faClipboard,
  faBox,
  faSort,
  faHandHoldingUsd,
  faPlusCircle,
  faCheckCircle,
  faExclamationCircle,
  faEllipsisV,
  faCheck,
  faMapMarkerAlt,
  faMapMarkedAlt,
  faStickyNote,
  faShippingFast,
  faMoneyBillWave,
  faReceipt,
  faUserCheck,
  faUserPlus,
  faPercent,
  faRobot,
  faFileExport,
  faUserFriends,
  faCommentAlt,
  faSmile,
  faAngry,
  faMobileAlt,
  faWindowMaximize,
  faMap,
  faImage,
  faSave,
  faPlusSquare,
  faCopy,
  faSortUp,
  faSyncAlt,
  faArchive
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VueEllipseProgress);
Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.use(VueAxios, axios);
Vue.use(vueNumeralFilterInstaller, { locale: "en-gb" });
Vue.use(VueCookies);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(ColorPanel);
Vue.use(ColorPicker);

Vue.use(ToggleButton);
Vue.use(Vuelidate);
import VueSlickCarousel from "vue-slick-carousel";
const Slick = {
  install(Vue) {
    Vue.component("slick", VueSlickCarousel);
  },
};

Vue.use(Slick);
Vue.use(VueMoment, {
  moment,
});
Vue.component("datetime", Datetime);
Vue.component("editor", editor);

const MODE = process.env.VUE_APP_MODE || "DEV";

Vue.prototype.$baseUrl = process.env[`VUE_APP_BASE_URL_${MODE}`];
Vue.prototype.$chatBaseUrl = process.env[`VUE_APP_CHAT_BASE_URL_${MODE}`];
Vue.prototype.$chatAgentWeb = process.env[`VUE_APP_CHAT_AGENT_WEB_${MODE}`];
Vue.prototype.$facebookAppId = process.env[`VUE_APP_FACEBOOK_APP_ID_${MODE}`];
Vue.prototype.$facebookSecret = process.env[`VUE_APP_FACEBOOK_SECRET_${MODE}`];
Vue.prototype.$chatAPIKey = process.env[`VUE_APP_CHAT_API_KEY_${MODE}`];
Vue.prototype.$dOrderBaseUrl = process.env[`VUE_APP_DORDER_BASE_URL_${MODE}`];
Vue.prototype.$dOrderAPIKey = process.env[`VUE_APP_DORDER_API_KEY_${MODE}`];
Vue.prototype.$tinyKey = process.env[`VUE_APP_TINY_KEY_${MODE}`];
Vue.prototype.$version = process.env[`VUE_APP_VERSION_${MODE}`];
Vue.prototype.$webhookApiBaseUrl =
  process.env[`VUE_APP_WEBHOOK_API_BASE_URL_${MODE}`];
console.log(`Running in ${MODE} mode`);

// if (MODE == "DEV") {
//   Vue.prototype.$baseUrl = "https://dev-master-chatbot-admin-api.d-dots.com/api";
//   Vue.prototype.$chatBaseUrl = "https://dev-master-chatbot-chatagent-api.d-dots.com/api";
//   Vue.prototype.$chatAgentWeb = "https://dev-master-chatbot-chatagent.d-dots.com";
//   Vue.prototype.$facebookAppId = "1395111664532367";
//   Vue.prototype.$facebookSecret = "a62a300483d2785185734166c3c18166";
//   Vue.prototype.$chatAPIKey = "lDd0T2cHa7s9sT3M";
//   Vue.prototype.$dOrderBaseUrl = "https://dev-master-chatbot-customer-api.d-dots.com/api";
//   Vue.prototype.$dOrderAPIKey = "ChAtA7Ds40p";
//   Vue.prototype.$tinyKey = "ih8i3lpm94w6qsyhwjh4861e60kfb8ptkee9vx6ftxwrsdnw";
//   // Vue.prototype.$lineliffAgentQRCode = "2006165859-NyOR5lZJ";
// } else if (MODE == "UAT") {
//   Vue.prototype.$baseUrl = " https://uat-master-chatbot-admin-api.d-dots.com/api";
//   Vue.prototype.$chatBaseUrl = "https://uat-master-chatbot-chatagent-api.d-dots.com/api";
//   Vue.prototype.$chatAgentWeb = "https://uat-master-chatbot-chatagent.d-dots.com";
//   Vue.prototype.$facebookAppId = "840312081270005";
//   Vue.prototype.$facebookSecret = "479c4c74a3dea591e67dcae8f5c93343";
//   Vue.prototype.$chatAPIKey = "lDd0T2cHa7s9sT3M";
//   Vue.prototype.$dOrderBaseUrl = "https://uat-master-chatbot-customer-api.d-dots.com/api";
//   Vue.prototype.$dOrderAPIKey = "ChAtA7Ds40p";
//   Vue.prototype.$tinyKey = "ih8i3lpm94w6qsyhwjh4861e60kfb8ptkee9vx6ftxwrsdnw";
//   // Vue.prototype.$lineliffAgentQRCode = "";
// }

Vue.prototype.$formatDate = "DD MMM YYYY";
Vue.prototype.$formatDateTime = "DD MMM YYYY (HH:mm)";
Vue.prototype.$formatTime = "HH:mm";

// API request
Vue.axios.interceptors.request.use(function (config) {
  config.headers.Authorization = Vue.$cookies.isKey(`${process.env.VUE_APP_MODE}-admin-token`)
    ? `Bearer ${Vue.$cookies.get(`${process.env.VUE_APP_MODE}-admin-token`)}`
    : "null";
  config.headers.BrandID =
    store.getters.getCurrentBrandID() == null
      ? 0
      : store.getters.getCurrentBrandID();

  return config;
});
// API response
Vue.axios.interceptors.response.use(
  function (response) {
    return Promise.resolve(response.data);
  },
  function (error) {
    if (error.response.status == 401) {
      Vue.$cookies.remove(`${process.env.VUE_APP_MODE}-admin-token`);
      Vue.$cookies.remove(`${process.env.VUE_APP_MODE}-admin-permissions`);
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

LuxonSettings.defaultLocale = "th";

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!VueCookies.get(`${process.env.VUE_APP_MODE}-admin-token`)) {
      next({
        path: "/login",
      });
    } else {
      let fromBrandID = from.query.brandID;
      if (to.name == "CHAT") {
        var myHeaders = new Headers();
        myHeaders.append("API-KEY", Vue.prototype.$chatAPIKey);
        myHeaders.append(
          "Authorization",
          "Bearer " + VueCookies.get(`${process.env.VUE_APP_MODE}-chat-agent-token`)
        );
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
          token: VueCookies.get(`${process.env.VUE_APP_MODE}-chat-agent-token`),
        });

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(Vue.prototype.$chatBaseUrl + "/session/encode", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.result) {
              window.location =
                Vue.prototype.$chatAgentWeb +
                "/decode/" +
                result.detail.sessionId +
                `?brandID=${fromBrandID}`;
            } else {
              window.location = `/login`;
            }
          })
          .catch((error) => {
            console.log("error", error);
            alert(error.message);
            window.location = `/login`;
          });
        return;
      }
      if (!to.query.brandID) {
        if (fromBrandID) {
          if (to.params.id) {
            next({
              name: to.name,
              query: { brandID: fromBrandID, ...to.query },
              params: { id: to.params.id, ...to.params },
            });
          } else {
            next({
              name: to.name,
              query: { brandID: fromBrandID, ...to.query },
            });
          }
          return;
        } else {
          next();
        }
      } else {
        let adminPermissions =
          Vue.$cookies.get(`${process.env.VUE_APP_MODE}-admin-permissions`) || [];
        let permissionId = to.meta?.permissionId || 0;
        if (permissionId == -1 || adminPermissions.includes(permissionId)) {
          next();
        } else {
          next({
            path: "/403",
            query: { brandID: fromBrandID, ...to.query },
          });
        }
        return;
      }
    }
  } else if (to.matched.some((record) => record.meta.requiresIsLogin)) {
    if (VueCookies.get(`${process.env.VUE_APP_MODE}-admin-token`)) {
      next({
        path: "/",
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

new Vue({
  el: "#app",
  library,
  i18n,
  router,
  icons,
  store,
  template: "<App/>",
  components: {
    App,
  },
});
